export default __webpack_public_path__ + "static/media/maiaicon.ea9ba901.png";